import type { Paged } from '../models/paged.ts'
import type { Hit } from 'algoliasearch'
import type { Parameters } from '../models/parameters.ts'
import type { AlgoliaFacet } from '../../data/algolia/algolia.facet.ts'
import type { ResponseWithFacetsDto } from '../../data/algolia/algolia-base.dto.ts'

export const mapAlgoliaPage = <
  H extends Hit,
  F extends AlgoliaFacet,
  I,
  P extends Parameters,
>(
  itemMapper: (from: H) => I,
  filtersMapper: (from: F) => P,
  dto: ResponseWithFacetsDto<H, F>
): Paged<I, P> => ({
  page: dto.page ?? 0,
  totalPages: dto.nbPages ?? 0,
  items: dto.hits.map((hit) => itemMapper(hit)),
  parameters: filtersMapper(dto.facets),
})
